import type RequestType from '@/data/request-type/model';
import { requestTypes } from '@/data/request-type/selectors';
import type { WiwState } from '@/store';

import { createSelector } from '@reduxjs/toolkit';
import { Map } from 'immutable';

export const getMatchedRipplingRequestTypes = (state: WiwState) =>
  state.integrations.rippling.configuration.get('request_types').matched || Map();

export const getRipplingRequestTypes = (state: WiwState) =>
  state.integrations.rippling.configuration.get('request_types').rippling || Map();

export const getUnmatchedWIWRequestTypes = createSelector(
  [requestTypes, getMatchedRipplingRequestTypes],
  (wiwRequestTypes, matchedRequestTypes) => {
    return wiwRequestTypes.filter(
      (requestType: RequestType) =>
        requestType.enabled && !requestType.is_deleted && !matchedRequestTypes.has(requestType.id),
    );
  },
);
